import React from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectInput } from '@/ui/components/shared/inputs/Dropdown/SelectInput';
import Button from '@/ui/components/shared/Button';
import { useTranslations } from 'next-intl';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { Option } from '@/ui/components/shared/multistepFormComponents/types';

export type DropdownSelectProps = {
  question: string;
  options: Option[];
  placeholder?: string;
  buttonClass?: string;
  optionsClass?: string;
  onSelect: (value: any) => void;
};

function ICDropdownSelect({
  question,
  options,
  placeholder = 'Select an option',
  buttonClass,
  optionsClass,
  onSelect,
}: DropdownSelectProps) {
  const { control, watch } = useFormContext();
  const t = useTranslations('IC_Survey');

  const selectedValue = watch(question);

  const mappedOptions = options.map((option) => ({
    value: option.value,
    label: option.text,
    prependItem: option.image ? (
      <img src={option.image} alt={option.text} className="mr-2 h-4 w-4" />
    ) : undefined,
  }));

  return (
    <div className="mx-auto flex h-full w-full max-w-lg flex-grow flex-col">
      <SelectInput
        name={question}
        control={control}
        options={mappedOptions}
        placeholder={placeholder}
        buttonClass={buttonClass}
        optionsClass={optionsClass}
      />
      <div className="flex flex-grow" />
      <Button
        className="mt-5 flex w-full items-center justify-center gap-1 pl-10"
        variant="yellowBlackBorder"
        type="button"
        onClick={() => onSelect(selectedValue)}
        disabled={!selectedValue}
      >
        {t('Next')}
        <ChevronRightIcon className="h-4 w-4 " />
      </Button>
    </div>
  );
}

export default ICDropdownSelect;
